document.addEventListener('DOMContentLoaded', function () {
  var BTW_RATE = 1.21;

  function parsePrice(text) {
    var m = text.match(/\d[\d.,]*\d|\d/);
    if (!m) return null;
    var raw = m[0];
    var lastSep = null;
    var lastSepIndex = -1;
    for (var i = raw.length - 1; i >= 0; i--) {
      if (raw.charAt(i) === '.' || raw.charAt(i) === ',') {
        lastSep = raw.charAt(i);
        lastSepIndex = i;
        break;
      }
    }
    var integerPart, decimalPart, decimalSep;
    if (lastSep && raw.length - lastSepIndex - 1 === 2) {
      decimalSep = lastSep;
      integerPart = raw.slice(0, lastSepIndex).replace(/[.,]/g, '');
      decimalPart = raw.slice(lastSepIndex + 1);
    } else {
      decimalSep = ',';
      integerPart = raw.replace(/[.,]/g, '');
      decimalPart = '00';
    }
    var value = parseFloat(integerPart + '.' + decimalPart);
    if (isNaN(value)) return null;
    return {
      value: value,
      decimalSep: decimalSep,
      matchIndex: m.index,
      matchText: m[0]
    };
  }

  function formatValue(value, decimalSep) {
    var rounded = Math.round((value + Number.EPSILON) * 100) / 100;
    var parts = rounded.toFixed(2).split('.');
    var intPart = parts[0];
    var decPart = parts[1];
    var thousandsSep = decimalSep === ',' ? '.' : ',';
    intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    return intPart + decimalSep + decPart;
  }

  function buildText(original, parsed, newValue) {
    var newRaw = formatValue(newValue, parsed.decimalSep);
    return original.slice(0, parsed.matchIndex) + newRaw + original.slice(parsed.matchIndex + parsed.matchText.length);
  }

  function initToggle(priceContainer) {
    if (priceContainer.dataset.btwInitialized) return;
    if (priceContainer.closest('.volume-pricing-note, price-per-item, volume-pricing')) return;
    if (priceContainer.parentElement && priceContainer.parentElement.querySelector('.volume-pricing-note')) return;

    var spans = priceContainer.querySelectorAll('.price-item--regular, .price-item--sale.price-item--last');
    var entries = [];

    spans.forEach(function (span) {
      if (span.closest('s')) return;
      var originalText = span.textContent;
      var parsed = parsePrice(originalText);
      if (!parsed) return;
      var exclValue = parsed.value / BTW_RATE;
      var exclText = buildText(originalText, parsed, exclValue);
      entries.push({ span: span, inclText: originalText, exclText: exclText });
    });

    if (entries.length === 0) return;

    priceContainer.dataset.btwInitialized = 'true';

    var toggle = document.createElement('div');
    toggle.className = 'btw-toggle';
    toggle.setAttribute('data-btw-toggle', '');

    var inclBtn = document.createElement('button');
    inclBtn.type = 'button';
    inclBtn.className = 'btw-toggle__btn is-active';
    inclBtn.setAttribute('data-btw-mode', 'incl');
    inclBtn.setAttribute('aria-pressed', 'true');
    inclBtn.textContent = 'Incl BTW';

    var exclBtn = document.createElement('button');
    exclBtn.type = 'button';
    exclBtn.className = 'btw-toggle__btn';
    exclBtn.setAttribute('data-btw-mode', 'excl');
    exclBtn.setAttribute('aria-pressed', 'false');
    exclBtn.textContent = 'Excl BTW';

    toggle.appendChild(inclBtn);
    toggle.appendChild(exclBtn);

    priceContainer.insertAdjacentElement('afterend', toggle);

    function setMode(mode) {
      entries.forEach(function (entry) {
        entry.span.textContent = mode === 'excl' ? entry.exclText : entry.inclText;
      });
      [inclBtn, exclBtn].forEach(function (btn) {
        var isActive = btn.getAttribute('data-btw-mode') === mode;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    inclBtn.addEventListener('click', function () {
      setMode('incl');
    });
    exclBtn.addEventListener('click', function () {
      setMode('excl');
    });
  }

  var mainPriceContainer = document.querySelector('product-info [id^="price-"]');
  if (mainPriceContainer) {
    initToggle(mainPriceContainer);

    var taxNotice = document.querySelector('product-info .product__tax');
    if (taxNotice) {
      taxNotice.style.display = 'none';
    }
  }
});
